<template>
  <div class="search-container">
    <span class="dropdown-label">{{ label }}</span>
    <div class="search-input">
      <input type="text" v-model="searchTerm" @keyup.enter="triggerSearch" :placeholder="placeholder"
             class="search-input-field" />
      <button @click="triggerSearch" @touchstart="triggerSearch" class="search-input-button bp-icon-Search"></button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, defineEmits, defineProps } from 'vue';

const emit = defineEmits(['search', 'updateValue']);

const props = defineProps({
  id: {
    type: String,
  },
  placeholder: {
    type: String,
    default: '',
  },
  initialValue: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: 'Label',
  },
  modelValue: {
    type: String
  }
});

const searchTerm = ref<string>((props.modelValue)?props.modelValue:props.initialValue);

const triggerSearch = () => {
    emit('search', searchTerm.value);
}

watch(() => props.modelValue, (newValue) => {
  if (newValue) {
    searchTerm.value = newValue;
  }
});


watch(searchTerm, (newValue) => {
  emit('updateValue', props.id, newValue);
});
</script>

<style lang="scss" scoped>
@import 'SearchInputComponent';
</style>